<!-- 知识大讲堂 -->
<template>
  <div style="height: 100%">
    <div
      class="information"
      style="padding-bottom: 30px"
    >
      <!-- 全部 -->
      <van-list
        :loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        offset="50"
        :immediate-check="false"
        @load="onLoad"
      >
        <div
          class="center"
          v-for="item in list"
          :key="item.index"
        >
          <router-link :to="'/home/classroom/particulars/' + item.RIId">
            <div class="Content">
              <div
                style="display: inline-block"
                class="ContentA"
              >
                <img
                  :src="item.Thematic"
                  alt=""
                  @error="handleImageError"
                />
              </div>
              <div
                style="display: inline-block; margin-left: 10px"
                class="ContentB"
              >
                <span
                  class="van-multi-ellipsis--l2"
                  style="color: #000; margin-bottom: 6px"
                >{{ item.Title }}</span>

                <span
                  class="centertime van-multi-ellipsis--l2"
                  style="margin-bottom: 6px"
                >{{ item.Summary }}</span>

                <span class="centertime">{{ item.IssTime }}</span>
              </div>
            </div>
          </router-link>
        </div>
        <!-- 没有更多数据了 -->
      </van-list>

    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Sticky } from "vant";
Vue.use(Sticky);
import { setOpenId, getOpenId } from "@/utils/auth";
import { WeGetGoodNewsPage, WeGetGNTypeList } from "@/api/Hyapi";
import { WePBGetRealInfoPage } from "@/api/RealInfo";
export default {
  data () {
    return {
      active: 0,
      tabactive: 0,
      akId: 0, //tab栏
      //资讯列表
      listfrom: {
        page: 0,
        limit: 10,
        PAKind: 8,
      }, //查询传参
      hidden: true, //没有更多数据了
      list: [],
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      tabList: [],
    };
  },
  methods: {
    handleImageError (event) {
      event.target.src =
        "https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/cb59.png";
    },
    // 切换资讯分类
    tabClick (e) {
      this.getList();
    },
    // 获取资讯分类
    getGNTypeList () {
      WeGetGNTypeList().then((res) => {
        this.tabList = res.data.data;
      });
    },
    // 上拉加载需要的函数
    onLoad () {
      this.listfrom.page = this.listfrom.page + 1;
      this.loading = true;
      this.getList();
    },
    // 获取分页列表
    getList () {
      WePBGetRealInfoPage(this.listfrom)
        .then((res) => {
          if (res.data.code == 0) {
            console.log(res);

            let rows = res.data.data; //请求返回当页的列表
            console.log(rows);

            // 加载状态结束

            if (rows == null || rows.length === 0) {
              // 加载结束
              console.log("结束");
              this.finished = true;
              return;
            }
            for (var i = 0; i < rows.length; i++) {
              if (rows[i].AImgUrl == "") {
                rows[i].AImgUrl =
                  "https://cuiyunapi.dexian.ren//upload/images/2021/7/873b94ff-81d.png";
              }
            }
            // 将新数据与老数据进行合并 concat合并数组
            this.list = this.list.concat(rows);

            if (this.list.length >= res.data.count) {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
        })
        .catch(() => { });
    },
  },
  mounted () {
    if (this.$route.query["openid"]) {
      setOpenId(this.$route.query["openid"]);
    }
    this.getGNTypeList();
  },
  created () {
    this.onLoad()
  }
};
</script>
<style>
.hidden {
  text-align: center;
  font-size: 12px;
  color: #ccc;
  margin: 10px 0px 25px 0px;
}
.center {
  /* border-bottom: 1px solid rgb(246, 243, 243); */
  box-shadow: 1px 1px 5px #e6e6e6;
  margin: 3%;
  border-radius: 5px;
}
</style>
